import React from "react";

import ContainerWithEllipses from "./ContainerWithEllipses";
import useAppStore from "../../../stores/appStore";
import { refEntityOptionsSelector } from "../../../stores/KnowledgeEditor/knowledgeEditorSelectors";

const DisplayReference = ({ value, refEntity }) => {
  const refEntityOptions = useAppStore(refEntityOptionsSelector);

  if (!refEntityOptions[refEntity]) return "Loading...";

  return (
    <ContainerWithEllipses>
      {refEntityOptions[refEntity][value]}
    </ContainerWithEllipses>
  );
};

export default DisplayReference;
